export function ModalDialogController ($uibModalInstance, $scope, $window, $translate, messages, workshopAPI) {
  $scope.cancel = function () {
    $uibModalInstance.close();
    messages.show($translate.instant('VEHICLE_VISUALS_SPACE.CAPRICORN_MESSAGE'), 'success')
  };
  
  $scope.upgrade = function () {
    $uibModalInstance.close();
    workshopAPI.get('/vehicle_visuals/subscribe_url').then(function (url) {
      $window.open(url, '_blank');
    }, function (err) {
      messages.error(err);
    });
  };
}